import { render } from "./BlogPostGallery.vue?vue&type=template&id=288a82c8&scoped=true"
import script from "./BlogPostGallery.vue?vue&type=script&lang=js"
export * from "./BlogPostGallery.vue?vue&type=script&lang=js"

import "./BlogPostGallery.vue?vue&type=style&index=0&id=288a82c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-288a82c8"]])

export default __exports__